module.exports = __webpack_public_path__ + "img/ic_codeshare.aca582f8.svg";